import { render, staticRenderFns } from "./CalcFormItemFibreUpper.vue?vue&type=template&id=665f743c&scoped=true&"
import script from "./CalcFormItemFibreUpper.vue?vue&type=script&lang=js&"
export * from "./CalcFormItemFibreUpper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665f743c",
  null
  
)

export default component.exports